import React, {useContext, useEffect, useState} from "react";
import TrackVASContext from "../../TrackVASContext";
import {PageTitle} from "../../../_metronic/layout/core";
import {GenericTable} from "../generic/table/GenericTable";
import {defaultList} from "../generic/InitialStates";
import {ActionsColumnFormatter} from "../../column-formatters/ActionsColumnFormatter";
import {ENTITY_ID_WATER_WASH, ENTITY_ID_BRANCH} from "../generic/Constants";
import {showConfirmDialog} from "../../generic-components/ConfirmDialog";
import {genericDelete, genericGetAll} from "../generic/crud";
import {showToast, TOAST_SUCCESS} from "../../utils/toast/Toast";
import {convertDateToRelativeTime} from "../../utils/Utils";

export function WaterWashPage() {
    const myData = useContext(TrackVASContext);
    const [reload, setReload] = useState(1);
    const [branches, setBranches] = useState([]);

    const profileBreadCrumbs = [
        {
            title: "Home",
            path: "/dashboard",
            isSeparator: false,
            isActive: false,
        },
        {
            title: "",
            path: "",
            isSeparator: true,
            isActive: false,
        },
    ];

    const DateFormatter = (cellContent, row) => {
        if (!cellContent) return "N/A";
        const date = new Date(cellContent);
        const formattedDate = date.toLocaleDateString('en-IN', {
            day: '2-digit',
            month: 'short',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit'
        });
        
        return (
            <div className="d-flex flex-column">
                <span className="text-gray-800 fw-bold">
                    {convertDateToRelativeTime(cellContent)}
                </span>
                <span className="text-muted" style={{ fontSize: '0.75rem' }}>
                    {formattedDate}
                </span>
            </div>
        );
    };

    const columns = [
        {
            dataField: "id",
            text: "Id",
            hidden: true
        },
        {
            dataField: "vehicleNumber",
            text: "Vehicle Number",
            sort: true,
            search: true,
            style: { fontWeight: 'bold' }
        },
        {
            dataField: "vehicleModelName",
            text: "Vehicle Model",
            sort: true,
            formatter: (cell) => cell || "N/A"
        },
        {
            dataField: "jobType",
            text: "Job Type",
            sort: true,
            formatter: (cell, row) => (
                <>
                    <span className="badge badge-light-primary">{cell?.replace('_', ' ') || "N/A"}</span>
                    {row.isRepeatWash && <span className="badge badge-light-warning ms-2">Repeat Wash</span>}
                </>
            )
        },
        {
            dataField: "advisorName",
            text: "Advisor",
            sort: true
        },
        {
            dataField: "createdOn",
            text: "Wash Date",
            formatter: DateFormatter,
            sort: true
        },
        {
            dataField: "branchName",
            text: "Branch",
            sort: true
        },
        {
            dataField: "action",
            text: "Actions",
            formatter: ActionsColumnFormatter,
            formatExtraData: {
                buttons: [
                    {
                        name: "Delete",
                        color: "danger",
                        icon: "trash-alt",
                        method: openDeleteDialog
                    }
                ],
            },
            classes: "text-right pr-0",
            headerClasses: "text-right pr-3",
            style: {
                minWidth: "100px",
            },
        },
    ];

    async function openDeleteDialog(row) {
        const result = await showConfirmDialog("Do you really want to delete this Water Wash record?");
        if (result) {
            genericDelete(ENTITY_ID_WATER_WASH, row.id).then(() => {
                showToast("Record Deleted!", TOAST_SUCCESS);
                reloadData();
            }).catch(() => {
            });
        }
    }

    function reloadData() {
        setReload(prev => prev + 1);
    }

    useEffect(() => {
        myData.setBaseData({
            toolBarButtons: [],
        });

        // Fetch branches for filter
        genericGetAll(ENTITY_ID_BRANCH, {
            page: 1,
            sizePerPage: 1000,
            currentIndex: 0
        }).then(({data}) => {
            if (data && data.entities) {
                const branchOptions = data.entities.map(branch => ({
                    id: branch.id,
                    name: branch.name
                }));
                setBranches(branchOptions);
            }
        }).catch(err => console.error("Error fetching branches", err));

        return () => {
            myData.setBaseData({
                toolBarButtons: []
            });
        };
    }, []);

    const filters = [
        {
            dataField: "branchId",
            text: "Branch",
            type: "select",
            options: branches
        }
    ];

    return (
        <>
            <PageTitle breadcrumbs={profileBreadCrumbs}>Water Wash Records</PageTitle>
            <div className="card card-body">
                <GenericTable
                    reload={reload}
                    defaultData={defaultList}
                    columns={columns}
                    entityId={ENTITY_ID_WATER_WASH}
                    filters={filters}
                />
            </div>
        </>
    );
}
